import { BodilColor } from '~src/branding';
import { formatCurrency } from '~src/util';

import { TooltipItem, TooltipWrapper } from './style';
import { EnergyCostGraphTooltipProps } from './types';

export const EnergyCostGraphTooltip = ({
  payload,
  beforeColor = BodilColor.ui.action.default,
  beforeTextColor = 'white',
  afterColor = BodilColor.base.default,
  afterTextColor = 'white',
  fontStyle,
}: EnergyCostGraphTooltipProps) => {
  if (!payload?.length) {
    return <></>;
  }

  const { month, annualPriceBefore, annualPriceAfter } = payload[0].payload;

  return (
    <TooltipWrapper {...{ fontStyle }}>
      <TooltipItem>{month}</TooltipItem>
      <div style={{ width: 'fit-content' }}>
        <TooltipItem background={beforeColor} color={beforeTextColor}>
          {formatCurrency(annualPriceBefore)}
        </TooltipItem>
        <TooltipItem background={afterColor} color={afterTextColor}>
          {formatCurrency(annualPriceAfter)}
        </TooltipItem>
      </div>
    </TooltipWrapper>
  );
};
